import React from 'react';
import { Redirect } from 'react-router-dom';
import { useCheckUserPermissions } from 'hooks/useChekUserPermissions';
import { useUserInformationContext } from 'contexts/userContext';

/** Text extraction and inference need both: analyzing documents and reading AI usage. Administrators hold every permission. */
export const IMPORTS_PERMISSIONS = ['getAnalyzeDocument', 'getAiUsage'] as const;

export const canUseImports = (hasPermission: (permission: string) => boolean): boolean => (
  IMPORTS_PERMISSIONS.every((permission) => hasPermission(permission))
);

/** Renders the Imports screen only for users who can use it; everyone else is sent to the home page. */
export const ImportsGate = ({ children }: { children: React.ReactElement }) => {
  const { currentUser } = useUserInformationContext();
  const { hasPermission } = useCheckUserPermissions(currentUser);
  // Wait for the user to load so a slow response is not mistaken for a missing permission.
  if (!currentUser) return null;
  return canUseImports(hasPermission) ? children : <Redirect to="/" />;
};
